export default __webpack_public_path__ + "static/media/moon.7fc55a62.png";